import React, { useEffect } from "react";
import ApplicationFiles from "../../components/applicationComponents/applicationFiles/ApplicationFilesComponent";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";

export default function ApplicationFilesPage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Application and Evidence Upload",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <ApplicationFiles disabled={false} />
    </>
  );
}
